<template>
  <div class="client-info-wrapper">
    <div v-for="(item, index) in displayItems" :key="index" class="label-and-value client-card">
      <div class="label">{{ $t('client') }}</div>
      <div class="value-cell">
        <div :class="['value', item.masked ? 'masked-value' : '']">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { MASKED_ANNOTATION } from 'smartbarcode-web-core/src/utils/constants'
import { IClientInfo } from 'smartbarcode-web-core/src/utils/types'

@Options({ name: 'ClientInfoBlock' })
export default class ClientInfoBlock extends Vue {
  @Prop({ type: Array, required: true }) readonly clients!: IClientInfo[]
  maskedUsers = 1

  get isAuth() {
    return this.$store.getters.isAuth
  }

  get displayItems() {
    if (this.isAuth) {
      return this.clients.map((c) => ({ name: c.name, masked: false }))
    }
    return Array.from({ length: this.maskedUsers }, () => ({ name: MASKED_ANNOTATION, masked: true }))
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixins.scss';

.masked-value {
  color: #ff0000;
}

.client-info-wrapper {
  padding-bottom: 12px;
}

.label-and-value.client-card {
  flex-direction: column;
  align-items: stretch;
  padding: 0;
  margin: 12px 12px 0 12px;
  border: 1px solid #c4c4c4;
  border-radius: 6px;
  overflow: hidden;
  background: transparent;

  > .label {
    text-align: center;
    flex-basis: auto;
    min-width: 0;
    width: 100%;
    margin: 0;
    padding: 8px 12px;
    box-sizing: border-box;
    background: #e8e8e8;
    border-bottom: 1px solid #c4c4c4;
    font-weight: 600;
    word-break: break-word;

    &::after {
      content: '';
    }
  }

  > .value-cell {
    flex-basis: auto;
    width: 100%;
    margin: 0;
    padding: 12px;
    box-sizing: border-box;
    justify-content: center;
    text-align: center;
    background: transparent;

    .value {
      display: block;
      width: 100%;
      margin: 0;
      padding: 0;
      text-align: center;
      background: transparent;
      border: none;
      font-weight: normal;
      word-break: break-word;
    }
  }
}
</style>
